var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import store from '../store/store';
import { getOptimizelyGoogleAnalyticsDimension } from '../store/selectors';
import { trackRootPathfinder } from './tracking';
import log from './log';
export default function pushOptimizelyEvent(eventName, module, additionalTags) {
    log.debug('Pushing optimizely event: ', eventName, module ? module : '', additionalTags ? additionalTags : '');
    window['optimizely'] = window['optimizely'] || [];
    window['optimizely'].push({
        type: 'event',
        eventName: eventName,
        tags: __assign({ revenue: 0, value: 0.0 }, additionalTags),
    });
    // we have GA integration with optimizely, send special tracking event
    var gaDimension = getOptimizelyGoogleAnalyticsDimension(store.getState());
    if (gaDimension > 0) {
        trackRootPathfinder({
            event: 'optimizely-integration',
            'optimizely-dimension-number': gaDimension,
        });
    }
}
